import React from "react";
import { ThemeContext } from "../../Context/theme";
import "./Navbar.css";
import Brightness2Icon from "@material-ui/icons/Brightness2";
import WbSunnyRoundedIcon from "@material-ui/icons/WbSunnyRounded";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
//import DownloadIcon from "@material-ui/icons/DownloadIcon";
//import DownloadIcon from '@mui/icons-material/Download';
//import SaveAltIcon from "mui/icons-material/SaveAlt";
import Resume from "../../Assets/Ruchi_Priya_Kumari_Resume.pdf";
import openInNewTab from "./newtabOpener";

export const Navbar = () => {
  const [{ themename, toggeltheme }] = React.useContext(ThemeContext);
  const [showNavList, setShowNavList] = React.useState(false);

  const toggleNavList = (id) => {
    var element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
    }
    setShowNavList(!showNavList);
  };
  return (
    <>
      <nav className="center nav" id="nav-menu">
        <ul
          style={{ display: showNavList ? "flex" : null }}
          className="nav__list"
        >
          <li className="nav__list-item nav-link home">
            <a
              href="#home"
              onClick={() => toggleNavList("#home")}
              className="link link--nav"
            >
              Home
            </a>
          </li>
          <li className="nav__list-item nav-link about">
            <a
              href="#aboutt"
              onClick={() => toggleNavList("#about")}
              className="link link--nav"
            >
              About Me
            </a>
          </li>
          <li className="nav__list-item nav-link skills">
            <a
              href="#skills"
              onClick={() => toggleNavList("#skills")}
              className="link link--nav"
            >
              Skills
            </a>
          </li>
          <li className="nav__list-item">
            <a
              href="#Github"
              onClick={() => toggleNavList("#Github")}
              className="link link--nav"
            >
              Statistics
            </a>
          </li>
          <li className="nav__list-item nav-link projects">
            <a
              href="#projects"
              onClick={() => toggleNavList("#projects")}
              className="link link--nav"
            >
              Projects
            </a>
          </li>
          <li className="nav__list-item nav-link contact">
            <a
              href="#contact"
              onClick={() => toggleNavList("#contact")}
              className="link link--nav"
            >
              Contact
            </a>
          </li>
          <li className="nav__list-item nav-link resume"  >
          {/* <button id="resume-button-1">
          <a id="resume-link-1"
              
              href="https://drive.google.com/file/d/1b0LhKlE7szGaHcfiWUqORDYuh1uwDXeL/view?usp=sharing" 
              // download="ruchi_priya_kumari.pdf"
              onClick={toggleNavList}
              className="link link--nav"
              target="_blank"
              rel="noreferrer"
              download
            >
              Resume
            
            </a>
          
          </button> */}

          <button
              id='resume-button-1'
              // width='max-content'
              // colorScheme={'teal'}
              onClick={() =>
                openInNewTab(
                  'https://drive.google.com/file/d/16cnSSGVz8BYM7OHiorVUtJNcpfi0/view?usp=drive_link'
                )
              }
            >
              <a
                href={Resume}
                download
                className='nav-link resume'
                id='resume-link-1'
              >
                
                  <p>Resume</p>
                  {/* <p >
                    <AiOutlineDownload fontSize={'1.2rem'} />
                  </p> */}
                
              </a>
            </button>
            
          </li>
          
        </ul>
        <button
          type="button"
          onClick={toggeltheme}
          className="btn btn--icon nav__theme"
          aria-label="toggle theme"
          style={{ backgroundColor: "inherit" }}
        >
          {themename === "dark" ? <WbSunnyRoundedIcon /> : <Brightness2Icon />}
        </button>
        <button
          type="button"
          onClick={toggleNavList}
          className="btn btn--icon nav__hamburger"
          aria-label="toggle navigation"
        >
          {showNavList ? <CloseIcon /> : <MenuIcon />}
        </button>
      </nav>
    </>
  );
};
